import React, { memo, useEffect, useState } from 'react';
import { Form, FormGroup, Input } from 'reactstrap';

type Props = {
    value?: string;
    placeholder?: string;
    onSubmit?: (searchKey: string) => void;
}

function SearchInput(props: Props) {
    const { value, placeholder, onSubmit } = props;

    const [searchKey, setSearchKey] = useState('');

    useEffect(() => {
        if (value !== searchKey) {
            setSearchKey(value || '');
        }
    }, [value]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchKey(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSubmit?.(searchKey);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup inline className="m-0">
                <Input
                    bsSize="sm"
                    placeholder={placeholder}
                    value={searchKey}
                    onChange={handleChange}
                />
            </FormGroup>
        </Form>
    );
}

export default memo(SearchInput);